// ** React import
import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Reactstrap Imports
import {
  Input,
  Label,
  Button,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledAccordion,
  Modal
} from "reactstrap"

// ** Third Party Components
import { useFormik } from "formik"
import { XCircle, Plus } from "react-feather"
import Select from "react-select"

const EducacionGarantizadaForm = (props) => {
  // ** State

  const respuestaSiNo = [
    {
      label: "Si",
      value: "Si"
    },
    {
      label: "No",
      value: "No"
    }
  ]

  function initialValues() {
    if (props.accion === 1) {
      return {
        importanteEducacion: "",
        universidadPrivada: "Si",
        costoUniversidad: "",
        hijos: []
      }
    } else {
      return props.data
    }
  }

  function createHijoObj() {
    return {
      nombreHijo: "",
      edadHijo: "",
      ahorro: "",
      plazo: "",
      ahorroMensual: "",
      ahorroTotal: ""
    }
  } 

  const formik = useFormik({
    initialValues: initialValues(),
    onSubmit: (data, { resetForm }) => {
      data = {
        ...data,
        accion: props.accion,
        tipo: "personal",
        nombre: "Educación garantizada",
        slug: "educacion-garantizada"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  function agregarHijo() {
    const hijoNewIndex = formik.values.hijos.length
    formik.setFieldValue(`hijos[${hijoNewIndex}]`, createHijoObj())
  }

  function eliminarHijo(index) {
    const newHijos = formik.values.hijos
    newHijos.splice(index, 1)
    formik.setFieldValue("hijos", newHijos)
  }

  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Educación garantizada</h1>
      <div className="mb-1">
        <Label className="form-label" htmlFor="importanteEducacion">
          ¿Del 1 al 10 que tan importante consideras que sera la educación
          superior en la vida profesional de tu hijos/nietos?
        </Label>
        <Input
          id="importanteEducacion"
          type="number"
          placeholder="Ingrese rango"
          value={formik.values.importanteEducacion}
          onChange={(e) => {
            formik.setFieldValue("importanteEducacion", e.target.value)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="universidadPrivada1">
          ¿Te interesaría que tus hijos/nietos se graduaran de una Universidad
          Privada?
        </Label>
        <Select
          id="universidadPrivada1"
          className="react-select w-25"
          classNamePrefix="select"
          defaultValue={respuestaSiNo[0]}
          value={{
            label: formik.values.universidadPrivada,
            value: formik.values.universidadPrivada
          }}
          onChange={(e) => {
            formik.setFieldValue("universidadPrivada", e.value)
          }}
          options={respuestaSiNo}
          isClearable={false}
          isSearchable={false}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label">
          ¿Sabes cuanto cuesta hoy en día una carrera Universitaria y cuanto
          costará en algunos años?
        </Label>
        <Input
          type="number"
          placeholder="Ingrese numero"
          value={formik.values.costoUniversidad}
          onChange={(e) => {
            formik.setFieldValue("costoUniversidad", e.target.value)
          }}
        />
      </div>
      {formik.values.hijos.length > 0 &&
        formik.values.hijos.map((_hijo, index) => (
          <div className="d-flex my-2" key={index}>
            <UncontrolledAccordion
              style={{ width: "95%" }}
              defaultOpen={[]}
              stayOpen
            >
              <AccordionItem>
                <AccordionHeader targetId="1">
                  Hijo/Nieto {index + 1}
                </AccordionHeader>
                <AccordionBody accordionId="1">
                  <div className="mb-1">
                    <Label className="form-label" htmlFor="nombreHijo">
                      Nombre de tu hijo/nieto
                    </Label>
                    <Input
                      id="nombreHijo"
                      placeholder="Ingresa el nombre"
                      type="text"
                      value={formik.values.hijos[index]["nombreHijo"]}
                      onChange={(e) => {
                        formik.setFieldValue(
                          `hijos[${index}].nombreHijo`,
                          e.target.value
                        )
                      }}
                    />
                  </div>
                  <div className="mb-1">
                    <Label className="form-label" htmlFor="edadHijo">
                      ¿Qué edad tienen tu hijo/nieto?
                    </Label>
                    <Input
                      id="edadHijo"
                      placeholder="Ingresa la edad"
                      type="number"
                      value={formik.values.hijos[index]["edadHijo"]}
                      onChange={(e) => {
                        formik.setFieldValue(
                          `hijos[${index}].edadHijo`,
                          e.target.value
                        )
                      }}
                    />
                  </div>
                  <div className="mb-1">
                    <Label className="form-label" htmlFor="ahorro">
                      ¿Cuanto tendrías que ahorrar para que a sus 18 años tengan
                      el recurso económico para que asistan a la Universidad?
                    </Label>
                    <Input
                      id="ahorro"
                      type="number"
                      placeholder="Ingrese cantidad"
                      value={formik.values.hijos[index]["ahorro"]}
                      onChange={(e) => {
                        formik.setFieldValue(
                          `hijos[${index}].ahorro`,
                          e.target.value
                        )
                      }}
                    />
                  </div>
                  <div className="mb-1">
                    <Label className="form-label" htmlFor="plazo">
                      ¿En que plazo tienes para ahorrarlo?
                    </Label>
                    <Input
                      id="plazo"
                      type="number"
                      value={formik.values.hijos[index]["plazo"]}
                      onChange={(e) => {
                        formik.setFieldValue(
                          `hijos[${index}].plazo`,
                          e.target.value
                        )
                      }}
                    />
                  </div>
                  <div className="mb-1">
                    <Label className="form-label" htmlFor="ahorroMensual">
                      Ahorro mensual requerido
                    </Label>
                    <Input
                      id="ahorroMensual"
                      type="number"
                      value={formik.values.hijos[index]["ahorroMensual"]}
                      onChange={(e) => {
                        formik.setFieldValue(
                          `hijos[${index}].ahorroMensual`,
                          e.target.value
                        )
                      }}
                    />
                  </div>
                  <p>{formik.values.hijos[index]["ahorroTotal"]}</p>
                </AccordionBody>
              </AccordionItem>
            </UncontrolledAccordion>
            <div>
              <XCircle
                color="red"
                className="cursor-pointer"
                onClick={() => {
                  eliminarHijo(index)
                }}
              />
            </div>
          </div>
        ))}
      <Button
        className="d-block my-2 btn-success"
        onClick={() => {
          agregarHijo()
        }}
      >
        <Plus size={"15px"} /> Agregar hijo/nieto
      </Button>

      <div className="d-flex justify-content-end">
        <Button color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default EducacionGarantizadaForm
